import name from './name'

const selectSliceData = state => state[name]

const selectHomePageSections = state => selectSliceData(state).sections
const selectHomePageSectionsLoading = state => selectSliceData(state).isLoading
const selectShouldLoad = state => selectSliceData(state).shouldLoad

export {
  selectHomePageSections,
  selectHomePageSectionsLoading,
  selectShouldLoad
}
